import { gql, TypedDocumentNode } from '@apollo/client';

import {
  ArcgisLayer,
  ArcgisLayerCreateInput,
  ArcgisLayerUpdateInput,
} from '@atom/types/arcgis';

export const BASE_ARCGIS_LAYER_FRAGMENT = gql`
  fragment BaseArcgisLayer on ArcgisLayer {
    id
    name
    link
    colorId
    iconType
    createdBy {
      firstName
      lastName
    }
    createdDate
    updatedBy {
      firstName
      lastName
    }
    updatedDate
  }
`;

export const GET_ARCGIS_LAYERS: TypedDocumentNode<{
  arcgisLayers: ArcgisLayer[];
}> = gql`
  query arcgisLayers {
    arcgisLayers {
      ...BaseArcgisLayer
    }
  }
  ${BASE_ARCGIS_LAYER_FRAGMENT}
`;

export const ARCGIS_LAYER_CREATE: TypedDocumentNode<
  { arcgisLayerCreate: ArcgisLayer },
  { input: ArcgisLayerCreateInput }
> = gql`
  mutation arcgisLayerCreate($input: ArcgisLayerCreateInput!) {
    arcgisLayerCreate(input: $input) {
      ...BaseArcgisLayer
    }
  }
  ${BASE_ARCGIS_LAYER_FRAGMENT}
`;

export const ARCGIS_LAYER_UPDATE: TypedDocumentNode<
  { arcgisLayerUpdate: ArcgisLayer },
  { input: ArcgisLayerUpdateInput }
> = gql`
  mutation arcgisLayerUpdate($input: ArcgisLayerUpdateInput!) {
    arcgisLayerUpdate(input: $input) {
      ...BaseArcgisLayer
    }
  }
  ${BASE_ARCGIS_LAYER_FRAGMENT}
`;

export const ARCGIS_LAYER_DELETE: TypedDocumentNode<
  { arcgisLayerDelete: boolean },
  { id: string }
> = gql`
  mutation arcgisLayerDelete($id: ID!) {
    arcgisLayerDelete(id: $id)
  }
`;
